// extracted by mini-css-extract-plugin
export default {"container":"Create_container__WWDCy","wrapper":"Create_wrapper__vWP6E"};